import { Modal, ModalContent, ModalTitle } from '../../../design-system/modal/modal';
import { Stack } from '../../../design-system/stack/stack';
import { InviteMemberForm, InviteMemberFormData } from './invite-member-form';

export type InviteMemberModalProps = {
  open: boolean;
  isLoading: boolean;
  onOpenChange: (open: boolean) => void;
  handleInviteMember: (email: string, firstName: string, lastName: string) => Promise<void>;
};

export const InviteMemberModal = ({ open, isLoading, onOpenChange, handleInviteMember }: InviteMemberModalProps) => {
  const handleSubmit = async (formValues: InviteMemberFormData) => {
    await handleInviteMember(formValues.email, formValues.firstName, formValues.lastName);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent className="h-fit max-w-lg px-7 py-6">
        <Stack space={3}>
          <ModalTitle className="text-lg font-medium text-black">Invite a Team Member</ModalTitle>
          <InviteMemberForm
            onSubmit={handleSubmit}
            isLoading={isLoading}
            formValues={{
              firstName: '',
              lastName: '',
              email: '',
              role: '',
            }}
            onCancel={() => onOpenChange(false)}
          />
        </Stack>
      </ModalContent>
    </Modal>
  );
};
